import React from "react";
import "../css/delivery.scss";
import { Link } from "react-router-dom";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <main className="layout--template" id="main_content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Shipping policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p>&nbsp;</p>
            <p>
              We use<span>&nbsp;</span>
              <strong>USPS&nbsp;</strong>or <strong>UPS</strong>
              <span>&nbsp;</span>for shipping. Depending on where you live, your
              order will arrive within 2-5 days after the order is shipped. Our
              processing time is usually 1-2 business days.&nbsp;&nbsp;
              <strong>NOTE:</strong>&nbsp;Some shipping delays are unavoidable -
              particularly during the holidays.
            </p>
            <p>
              In <strong>Texas</strong>, Free Shipping is available for orders
              above $<strong>45.00</strong>. For orders in the{" "}
              <strong>rest of the US</strong> Free Shipping is available for
              orders above $<strong>75.00</strong>.
            </p>
            <p>
              <strong>For Expedited Shipping</strong>, please call us at{" "}
              <strong>972-960-1521</strong> to discuss the timeframe and
              pricing.&nbsp;
            </p>
            <p>
              <strong>International Orders</strong> are shipped&nbsp;at
              the&nbsp;
              <strong>
                cost<span>&nbsp;</span>
              </strong>
              estimated by&nbsp;<strong>USPS Priority Mail</strong>. The charge
              will be reflected at checkout.{" "}
              <strong>We DO NOT ship to EU, EEA or to th UK</strong>
            </p>
            <p>
              Contact us when shipping internationally. Rates and availability
              differ by location; some countries charge duty for specific
              products.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>SHIPPING PROTECTION</strong>:
            </p>
            <p className="p1">
              We do our best to ensure your items arrive to you safely but
              sometimes things happen. If you selected package protection,
              rest assured that your package is protected! With package
              protection, in the event that your package is lost, stolen, or
              damaged while in transit, we will replace it free of charge. To
              start a shipping claim, please click{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>
              .
            </p>
            <p className="p1">
              <br />
              <strong>SHIPPING QUESTIONS?</strong>
              <span>&nbsp;</span>Contact us at:&nbsp;
              <a href="mailto:steps@tugglefield.xyz">
                steps@tugglefield.xyz
              </a>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Delivery;
